export const joinClasses = (classes) => classes.filter(x => !!x).join(' ');